module.exports = __webpack_public_path__ + "img/9788971848272.e83954fc.jpg";